module.exports = __webpack_public_path__ + "img/damInflated.b8abe307.svg";